var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FOLDER_PAGE, RECENT_PAGE, ROOT_FOLDER_PAGE, SEARCH_PAGE, SHARES_PAGE, STARRED_PAGE, TRASH_PAGE } from '../models/drive-page';
var RecentEntriesPageOpened = /** @class */ (function () {
    function RecentEntriesPageOpened() {
        this.page = RECENT_PAGE;
        this.queryParams = { orderBy: 'created_at', recentOnly: true };
    }
    RecentEntriesPageOpened.type = '[Drive] Recent Entries Page Opened';
    return RecentEntriesPageOpened;
}());
export { RecentEntriesPageOpened };
var FolderPageOpened = /** @class */ (function () {
    function FolderPageOpened(folderHash) {
        this.queryParams = {};
        var page = folderHash === 'root' ? ROOT_FOLDER_PAGE : FOLDER_PAGE;
        this.page = __assign({}, page, { folderHash: folderHash });
    }
    FolderPageOpened.type = '[Drive] Folder Page Opened';
    return FolderPageOpened;
}());
export { FolderPageOpened };
var SharesFolderOpened = /** @class */ (function () {
    function SharesFolderOpened() {
        this.page = SHARES_PAGE;
        this.queryParams = { sharedOnly: true };
    }
    SharesFolderOpened.type = '[Drive] Shared with me folder opened';
    return SharesFolderOpened;
}());
export { SharesFolderOpened };
var TrashPageOpened = /** @class */ (function () {
    function TrashPageOpened() {
        this.page = TRASH_PAGE;
        this.queryParams = { deletedOnly: true };
    }
    TrashPageOpened.type = '[Drive] Trash Page Opened';
    return TrashPageOpened;
}());
export { TrashPageOpened };
var SearchPageOpened = /** @class */ (function () {
    function SearchPageOpened(queryParams) {
        if (queryParams === void 0) { queryParams = {}; }
        this.queryParams = queryParams;
        this.page = SEARCH_PAGE;
    }
    SearchPageOpened.type = '[Drive] Search Page Opened';
    return SearchPageOpened;
}());
export { SearchPageOpened };
var StarredPageOpened = /** @class */ (function () {
    function StarredPageOpened() {
        this.page = STARRED_PAGE;
        this.queryParams = { starredOnly: true };
    }
    StarredPageOpened.type = '[Drive] Starred Entries Page Opened';
    return StarredPageOpened;
}());
export { StarredPageOpened };
var EntriesSelectedViaDrag = /** @class */ (function () {
    function EntriesSelectedViaDrag(entries) {
        this.entries = entries;
    }
    EntriesSelectedViaDrag.type = '[Drive] Entries Selected Via Drag';
    return EntriesSelectedViaDrag;
}());
export { EntriesSelectedViaDrag };
var EntrySelectedViaContextMenu = /** @class */ (function () {
    function EntrySelectedViaContextMenu(entries) {
        this.entries = entries;
    }
    EntrySelectedViaContextMenu.type = '[Drive] File Selected Via ContextMenu';
    return EntrySelectedViaContextMenu;
}());
export { EntrySelectedViaContextMenu };
var EntryTapped = /** @class */ (function () {
    function EntryTapped(entry, ctrlKey) {
        if (ctrlKey === void 0) { ctrlKey = false; }
        this.entry = entry;
        this.ctrlKey = ctrlKey;
    }
    EntryTapped.type = '[Drive] User Tapped File';
    return EntryTapped;
}());
export { EntryTapped };
var EntryDoubleTapped = /** @class */ (function () {
    function EntryDoubleTapped(entry) {
        this.entry = entry;
    }
    EntryDoubleTapped.type = '[Drive] User Double Tapped Entry';
    return EntryDoubleTapped;
}());
export { EntryDoubleTapped };
var FileDeleteSuccess = /** @class */ (function () {
    function FileDeleteSuccess(deletedFiles) {
        this.deletedFiles = deletedFiles;
    }
    FileDeleteSuccess.type = '[Drive] Successfully Deleted Files';
    return FileDeleteSuccess;
}());
export { FileDeleteSuccess };
var EntryContextMenuOpened = /** @class */ (function () {
    function EntryContextMenuOpened(entry) {
        this.entry = entry;
    }
    EntryContextMenuOpened.type = '[Drive] Entry Context Menu Opened';
    return EntryContextMenuOpened;
}());
export { EntryContextMenuOpened };
var NewFolderCreated = /** @class */ (function () {
    function NewFolderCreated(folder) {
        this.folder = folder;
    }
    NewFolderCreated.type = '[Drive] New Folder Created';
    return NewFolderCreated;
}());
export { NewFolderCreated };
var EntryRenamed = /** @class */ (function () {
    function EntryRenamed(entry, newName) {
        this.entry = entry;
        this.newName = newName;
    }
    EntryRenamed.type = '[Drive] Entry Renamed';
    return EntryRenamed;
}());
export { EntryRenamed };
var StartedDragging = /** @class */ (function () {
    function StartedDragging() {
    }
    StartedDragging.type = '[Drive] Started Dragging';
    return StartedDragging;
}());
export { StartedDragging };
var StoppedDragging = /** @class */ (function () {
    function StoppedDragging() {
    }
    StoppedDragging.type = '[Drive] Stopped Dragging';
    return StoppedDragging;
}());
export { StoppedDragging };
var MoveEntriesSuccess = /** @class */ (function () {
    function MoveEntriesSuccess(destination, oldLocation, entries) {
        this.destination = destination;
        this.oldLocation = oldLocation;
        this.entries = entries;
    }
    MoveEntriesSuccess.type = '[Drive API] Move Entries Success';
    return MoveEntriesSuccess;
}());
export { MoveEntriesSuccess };
var MoveEntriesFailed = /** @class */ (function () {
    function MoveEntriesFailed(messages) {
        this.messages = messages;
    }
    MoveEntriesFailed.type = '[Drive API] Move Entries Failed';
    return MoveEntriesFailed;
}());
export { MoveEntriesFailed };
var TrashedEntriesDeleteSuccess = /** @class */ (function () {
    function TrashedEntriesDeleteSuccess(entries) {
        this.entries = entries;
    }
    TrashedEntriesDeleteSuccess.type = '[Drive API] Trashed Entries Delete Forever Success';
    return TrashedEntriesDeleteSuccess;
}());
export { TrashedEntriesDeleteSuccess };
var TrashedEntriesRestoreSuccess = /** @class */ (function () {
    function TrashedEntriesRestoreSuccess(entries) {
        this.entries = entries;
    }
    TrashedEntriesRestoreSuccess.type = '[Drive API] Trashed Entries Restore Success';
    return TrashedEntriesRestoreSuccess;
}());
export { TrashedEntriesRestoreSuccess };
var NotEnoughSpaceError = /** @class */ (function () {
    function NotEnoughSpaceError() {
    }
    NotEnoughSpaceError.type = '[Drive] Not Enough Space Error';
    return NotEnoughSpaceError;
}());
export { NotEnoughSpaceError };
var UserSpaceUsageChanged = /** @class */ (function () {
    function UserSpaceUsageChanged() {
    }
    UserSpaceUsageChanged.type = '[Drive] User Space Usage Changed';
    return UserSpaceUsageChanged;
}());
export { UserSpaceUsageChanged };
var BreakpointChanged = /** @class */ (function () {
    function BreakpointChanged(status) {
        this.status = status;
    }
    BreakpointChanged.type = '[Drive] BreakpointChanged';
    return BreakpointChanged;
}());
export { BreakpointChanged };
